// The app-wide client providers, mounted once by `app/layout.tsx`. DESIGN.md §3: "FE data access:
// TanStack Query + openapi-fetch." A fresh `QueryClient` per component instance (via `useState`,
// never a module-level singleton) is the documented pattern for React Server Components, so a
// server-rendered request never leaks its cache into another visitor's request.
'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

export function AppProviders({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // The backend is the source of truth for every figure this product shows; a silent
            // background refetch on window focus would be surprising on a money screen, so pages
            // that want freshness ask for it explicitly (`refetchInterval`, `invalidateQueries`).
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
  );
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
